
import { RevSkeleton } from '@backmarket/design-system'

export default {
  components: {
    RevSkeleton,
  },
  props: {
    label: {
      type: String,
      default: 'Content placeholder',
    },
  },
}
